import { addDays, endOfDay, startOfDay } from 'date-fns';

export const FACILITY_RESERVATION_APPLICATION_WINDOW_DAYS = 30;

export const getFacilityReservationApplicationWindowStart = (
  today: Date = new Date(),
  minimumAdvanceDays = 0
) => startOfDay(addDays(startOfDay(today), minimumAdvanceDays));

export const getFacilityReservationApplicationWindowEnd = (
  today: Date = new Date(),
  windowDays = FACILITY_RESERVATION_APPLICATION_WINDOW_DAYS
) => endOfDay(addDays(startOfDay(today), windowDays));

export const isWithinFacilityReservationApplicationWindow = (
  reservationDate: Date,
  today: Date = new Date(),
  minimumAdvanceDays = 0,
  windowDays = FACILITY_RESERVATION_APPLICATION_WINDOW_DAYS
) => {
  const selectedDay = startOfDay(reservationDate);
  const windowStart = getFacilityReservationApplicationWindowStart(today, minimumAdvanceDays);
  const windowEnd = getFacilityReservationApplicationWindowEnd(today, windowDays);

  return selectedDay.getTime() >= windowStart.getTime() && selectedDay.getTime() <= windowEnd.getTime();
};

export const getFacilityReservationApplicationWindowMessage = (
  windowDays = FACILITY_RESERVATION_APPLICATION_WINDOW_DAYS
) => `예약은 신청일 기준 ${windowDays}일 이내 날짜만 선택할 수 있습니다.`;
